import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { localConfig } from '../../../Configs/localConfig'
import { api } from '../../api'

type PropsCultura = {
  cod_cultura: number
  cod_fertilizante?: number
  dose: string | number
  min_dose: string | number
  max_dose: string | number
}

interface PropsPostFertilizantes {
  nome: string
  observacao: string
  densidade: string | number
  aminoacido: string | number
  aminoacido_descricao: string
  hormonio_regulador: string | number
  hormonio_regulador_descricao: string
  indutor_resistencia: string | number
  indutor_resistencia_descricao: string
  biologicos: string | number
  biologicos_descricao: string
  ponto_deliquescencia: string | number
  solubilidade: string | number
  indice_salino: string | number
  extrato_de_alga: string | number
  extrato_de_alga_descricao: string
  aplicacoes: number[]
  aplicacoes_remover?: number[]
  funcoes: number[]
  funcoes_remover?: number[]
  culturas: PropsCultura[]
  culturas_remover?: PropsCultura[]
  cod_formulacao: number
  cod_marca: number
  n: string | number
  p: string | number
  k: string | number
  ca: string | number
  mg: string | number
  s: string | number
  b: string | number
  cu: string | number
  fe: string | number
  mn: string | number
  zn: string | number
  co: string | number
  mo: string | number
  ni: string | number
  si: string | number
  se: string | number
  refetch: Function
}

export const usePostFertilizante = (): {
  carregando_salvar_fertilizante: boolean
  mutate_fertilizante: (params: PropsPostFertilizantes) => void
  isSuccess_fertilizante: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostFertilizantes> = useMutation(
    async (params: PropsPostFertilizantes) => {
      const {
        nome,
        observacao,
        densidade,
        aminoacido,
        aminoacido_descricao,
        indice_salino,
        extrato_de_alga,
        extrato_de_alga_descricao,
        hormonio_regulador,
        hormonio_regulador_descricao,
        biologicos,
        biologicos_descricao,
        indutor_resistencia,
        indutor_resistencia_descricao,
        ponto_deliquescencia,
        solubilidade,
        aplicacoes,
        funcoes,
        culturas,
        cod_formulacao,
        cod_marca,
        n,
        p,
        k,
        ca,
        mg,
        s,
        b,
        cu,
        fe,
        mn,
        zn,
        co,
        mo,
        ni,
        si,
        se,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`/fertilizante?codConta=${localConfig()?.conta}`, {
          nome: nome,
          observacao: observacao,
          densidade: densidade,
          aminoacido: aminoacido,
          aminoacido_descricao: aminoacido_descricao,
          indice_salino: indice_salino,
          extrato_de_alga: extrato_de_alga,
          extrato_de_alga_descricao: extrato_de_alga_descricao,
          hormonio_regulador: hormonio_regulador,
          hormonio_regulador_descricao: hormonio_regulador_descricao,
          biologicos: biologicos,
          biologicos_descricao: biologicos_descricao,
          indutor_resistencia: indutor_resistencia,
          indutor_resistencia_descricao: indutor_resistencia_descricao,
          ponto_deliquescencia: ponto_deliquescencia,
          solubilidade: solubilidade,
          aplicacoes: aplicacoes,
          funcoes: funcoes,
          culturas: culturas,
          cod_formulacao: cod_formulacao,
          cod_marca: cod_marca,
          n: n,
          p: p,
          k: k,
          ca: ca,
          mg: mg,
          s: s,
          b: b,
          cu: cu,
          fe: fe,
          mn: mn,
          zn: zn,
          co: co,
          mo: mo,
          ni: ni,
          si: si,
          se: se,
          refetch: refetch,
        })
        .then((response: any) => {
          successAlert('Fertilizante cadastrado com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
       
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar fertilizante!', 5000, 'loading')
            })
          } else {
         
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar fertilizante!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_fertilizante: mutation.isLoading,
    mutate_fertilizante: mutation.mutate,
    isSuccess_fertilizante: mutation.isSuccess,
  }
}

export const usePutFertilizante = (
  cod: number
): {
  carregando_edit_fertilizante: boolean
  mutate_edit_fertilizante: (params: PropsPostFertilizantes) => void
  isSuccess_edit_fertilizante: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostFertilizantes> = useMutation(
    async (params: PropsPostFertilizantes) => {
      const {
        nome,
        observacao,
        densidade,
        aminoacido,
        aminoacido_descricao,
        indice_salino,
        extrato_de_alga,
        extrato_de_alga_descricao,
        hormonio_regulador,
        hormonio_regulador_descricao,
        biologicos,
        biologicos_descricao,
        indutor_resistencia,
        indutor_resistencia_descricao,
        ponto_deliquescencia,
        solubilidade,
        aplicacoes,
        aplicacoes_remover,
        funcoes_remover,
        funcoes,
        culturas,
        culturas_remover,
        cod_formulacao,
        cod_marca,
        n,
        p,
        k,
        ca,
        mg,
        s,
        b,
        cu,
        fe,
        mn,
        zn,
        co,
        mo,
        ni,
        si,
        se,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`/fertilizante/${cod}?codConta=${localConfig()?.conta}`, {
          nome: nome,
          observacao: observacao,
          densidade: densidade,
          aminoacido: aminoacido,
          aminoacido_descricao: aminoacido_descricao,
          indice_salino: indice_salino,
          extrato_de_alga: extrato_de_alga,
          extrato_de_alga_descricao: extrato_de_alga_descricao,
          hormonio_regulador: hormonio_regulador,
          hormonio_regulador_descricao: hormonio_regulador_descricao,
          biologicos: biologicos,
          biologicos_descricao: biologicos_descricao,
          indutor_resistencia: indutor_resistencia,
          indutor_resistencia_descricao: indutor_resistencia_descricao,
          ponto_deliquescencia: ponto_deliquescencia,
          solubilidade: solubilidade,
          aplicacoes: aplicacoes,
          aplicacoes_remover: aplicacoes_remover,
          funcoes: funcoes,
          funcoes_remover: funcoes_remover,
          culturas: culturas,
          culturas_remover: culturas_remover,
          cod_formulacao: cod_formulacao,
          cod_marca: cod_marca,
          n: n,
          p: p,
          k: k,
          ca: ca,
          mg: mg,
          s: s,
          b: b,
          cu: cu,
          fe: fe,
          mn: mn,
          zn: zn,
          co: co,
          mo: mo,
          ni: ni,
          si: si,
          se: se,
          refetch: refetch,
        })
        .then((response: any) => {
          successAlert('Fertilizante atualizado com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          errorAlert(
            error?.response?.data?.error ?? 'Falha ao editar a fertilizante!',
            5000,
            'loading'
          )
          throw error
        })
    }
  )

  return {
    carregando_edit_fertilizante: mutation.isLoading,
    mutate_edit_fertilizante: mutation.mutate,
    isSuccess_edit_fertilizante: mutation.isSuccess,
  }
}
